// import React, { useState, useEffect } from "react";
// import { Row, Col, Breadcrumb, Card, Container, Table } from "react-bootstrap";
// import "../assets/css/Checkout.css";
// import { InputText } from "primereact/inputtext";
// import { Button } from "primereact/button";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { RadioButton } from "primereact/radiobutton";
// import { Checkbox } from "primereact/checkbox";
// import "react-credit-cards-2/dist/es/styles-compiled.css";
// import { Dialog } from "primereact/dialog";
// import Privacypolicy from "../pages/Policy/Privacypolicy";
// import TermsAndCondition from "../pages/Policy/TermsAndCondition";
// import api from "../api/axios";
// import { Sidebar } from "primereact/sidebar";
// import { toast, Bounce } from "react-toastify";
// import SEO from "../components/SEO";
// import { loadRazorpayScript } from "../utils/loadRazorpayScript";

// const emitToast = (message, type = "default", autoClose = 5000) => {
//   toast(message, {
//     position: "bottom-left",
//     autoClose,
//     hideProgressBar: false,
//     closeOnClick: false,
//     pauseOnHover: true,
//     draggable: true,
//     theme: "dark",
//     transition: Bounce,
//     type,
//   });
// };

// const GST_RATE = 0.18;

// const Checkout = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const subscriptionId = location.state?.subscriptionId;

//   const [visible, setVisible] = useState(false);
//   const [visible2, setVisible2] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [paymentLoading, setPaymentLoading] = useState(false);

//   const [subscription, setSubscription] = useState(null);

//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [email, setEmail] = useState("");

//   const [addresses, setAddresses] = useState([]);
//   const [defaultAddressId, setDefaultAddressId] = useState(null);
//   const [selectedAddressId, setSelectedAddressId] = useState(null);

//   const [sidebarVisible, setSidebarVisible] = useState(false);
//   const [editingAddress, setEditingAddress] = useState(null);

//   const [checked, setChecked] = useState(false);
//   const [showPromo, setShowPromo] = useState(false);
//   const [promo, setPromo] = useState("");

//   const [coupon, setCoupon] = useState(null);
//   const [discountAmount, setDiscountAmount] = useState(0);

//   const removeCoupon = () => {
//     setCoupon(null);
//     setDiscountAmount(0);
//     setPromo("");
//     emitToast("Coupon removed", "info", 2000);
//   };

//   useEffect(() => {
//     if (!subscriptionId) {
//       navigate("/pricing");
//       return;
//     }

//     const fetchSubscription = async () => {
//       try {
//         const res = await api.get(
//           `/SubscriptionRoutes/subscriptions/${subscriptionId}`
//         );
//         setSubscription(res.data.data);
//       } catch (err) {
//         console.error("Invalid subscription");
//         navigate("/pricing");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSubscription();
//   }, [subscriptionId, navigate]);

//   const total = Number(subscription?.price || 0);
//   const basePrice = total / (1 + GST_RATE);

//   const discountBase = coupon
//     ? (basePrice * Number(coupon.discount_value)) / 100
//     : 0;

//   const discountedBase = basePrice - discountBase;
//   const gst = discountedBase * GST_RATE;

//   const subtotal = Number(discountedBase.toFixed(2));
//   const gstAmount = Number(gst.toFixed(2));
//   const finalPrice = Number((subtotal + gstAmount).toFixed(2));

//   const openAddAddress = () => {
//     setEditingAddress({
//       phone_no: "",
//       address_type: "shipping",
//       is_default: false,
//       address1: "",
//       address2: "",
//       city: "",
//       state: "",
//       country: "India",
//       zipcode: "",
//       gst_no: "",
//     });
//     setSidebarVisible(true);
//   };

//   const openEditAddress = (address) => {
//     setEditingAddress({ ...address });
//     setSidebarVisible(true);
//   };

//   useEffect(() => {
//     const fetchProfile = async () => {
//       try {
//         const res = await api.get(
//           `/customerProfileRoutes/customer_profile_data`
//         );

//         if (res.data.success) {
//           const customer = res.data.data;

//           setFirstName(customer.C_fname);
//           setLastName(customer.C_lname);
//           setEmail(customer.C_email);
//           setChecked(customer.is_subscribed);

//           if (customer.details?.length) {
//             setAddresses(customer.details);

//             const defaultAddr = customer.details.find((d) => d.is_default);
//             setDefaultAddressId(defaultAddr?.customer_details_id || null);
//           } else {
//             setAddresses([]);
//           }
//         }
//       } catch (err) {
//         console.error("Profile fetch error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProfile();
//   }, []);

//   useEffect(() => {
//     if (addresses.length > 0) {
//       const defaultAddr = addresses.find((a) => a.is_default);
//       setSelectedAddressId(
//         defaultAddr
//           ? defaultAddr.customer_details_id
//           : addresses[0].customer_details_id
//       );
//     }
//   }, [addresses]);

//   if (loading) {
//     return (
//       <Container className="py-5 text-center">
//         <h4>Loading checkout...</h4>
//       </Container>
//     );
//   }

//   const saveAddress = async () => {
//     if (!editingAddress) return;

//     try {
//       setLoading(true);

//       const payload = {
//         customer_details_id: editingAddress.customer_details_id || undefined,
//         phone_no: editingAddress.phone_no,
//         address_type: editingAddress.address_type || "shipping",
//         is_default: editingAddress.is_default,
//         address1: editingAddress.address1,
//         address2: editingAddress.address2,
//         city: editingAddress.city,
//         state: editingAddress.state,
//         country: editingAddress.country || "India",
//         zipcode: editingAddress.zipcode,
//       };

//       const { data } = await api.post(
//         `/customerProfileRoutes/customer/address_update`,
//         payload
//       );

//       if (!data.success) return;

//       const savedAddress = data.data;

//       setAddresses((prev) => {
//         if (editingAddress.customer_details_id) {
//           return prev.map((addr) =>
//             addr.customer_details_id === savedAddress.customer_details_id
//               ? savedAddress
//               : savedAddress.is_default
//                 ? { ...addr, is_default: false }
//                 : addr
//           );
//         }

//         return savedAddress.is_default
//           ? [...prev.map((addr) => ({ ...addr, is_default: false })), savedAddress]
//           : [...prev, savedAddress];
//       });

//       if (savedAddress.is_default) {
//         setDefaultAddressId(savedAddress.customer_details_id);
//       }

//       setSidebarVisible(false);
//       setEditingAddress(null);
//     } catch (error) {
//       console.error("Save address error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const startRazorpayPayment = async () => {
//     if (paymentLoading) return;

//     try {
//       const selectedAddress = addresses.find(
//         (a) => a.customer_details_id === selectedAddressId
//       );

//       if (!selectedAddress) {
//         emitToast("Please select a billing address", "warning", 3000);
//         return;
//       }

//       setPaymentLoading(true);

//       const razorpayLoaded = await loadRazorpayScript();

//       if (!razorpayLoaded) {
//         emitToast("Failed to load payment gateway", "error", 3000);
//         return;
//       }

//       emitToast("Initializing payment…", "info", 2000);

//       const { data } = await api.post(`/paymentrzrrts/payments/create-order`, {
//         subscription_id: subscription.subscription_id,
//         discount_code: coupon?.discount_code || null,
//         address: {
//           customer_details_id: selectedAddress.customer_details_id,
//           phone: selectedAddress.phone_no,
//           email,
//           address1: selectedAddress.address1,
//           address2: selectedAddress.address2,
//           city: selectedAddress.city,
//           state: selectedAddress.state,
//           country: selectedAddress.country,
//           zipcode: selectedAddress.zipcode,
//           gst_no: selectedAddress.gst_no || null,
//         },
//       });

//       if (!data?.success) {
//         emitToast("Failed to initialize payment", "error");
//         return;
//       }

//       const { razorpay_subscription_id, customer_order_id, key } = data.data;

//       const options = {
//         key,
//         subscription_id: razorpay_subscription_id,
//         name: "Shaadi Material",
//         description: subscription.sub_name,

//         handler: async (response) => {
//           try {
//             emitToast("Verifying payment…", "info", 2000);

//             const verifyRes = await api.post(`/paymentrzrrts/payments/verify`, {
//               razorpay_payment_id: response.razorpay_payment_id,
//               razorpay_subscription_id,
//               customer_order_id,
//               subscription_id: subscription.subscription_id,
//               customer_details_id: selectedAddress.customer_details_id,
//             });

//             const verifyData = verifyRes.data?.data;

//             emitToast("Payment successful 🎉", "success", 4000);

//             navigate("/thankyou", {
//               state: {
//                 paymentStatus: "success",
//                 verifyData,
//                 customer: {
//                   firstName,
//                   lastName,
//                   email,
//                 },
//                 address: selectedAddress,
//               },
//             });
//           } catch (verifyErr) {
//             console.error("Verify error:", verifyErr);

//             emitToast(
//               verifyErr.response?.data?.message || "Payment verification failed",
//               "error"
//             );

//             navigate("/thankyou", {
//               state: {
//                 paymentStatus: "failed",
//                 message:
//                   verifyErr.response?.data?.message || "Payment verification failed",
//               },
//             });
//           } finally {
//             setPaymentLoading(false);
//           }
//         },

//         prefill: {
//           name: `${firstName} ${lastName}`,
//           email,
//           contact: selectedAddress.phone_no,
//         },

//         theme: { color: "#c59d5f" },

//         modal: {
//           ondismiss: async () => {
//             try {
//               emitToast("Payment cancelled", "info", 2500);

//               if (customer_order_id) {
//                 await api.post("/paymentrzrrts/payments/cancel-order", {
//                   customer_order_id,
//                 });
//               }

//               navigate("/thankyou", {
//                 state: {
//                   paymentStatus: "cancelled",
//                   message: "You cancelled the payment before completing it.",
//                   customer: {
//                     firstName,
//                     lastName,
//                     email,
//                   },
//                   subscription: {
//                     sub_name: subscription?.sub_name,
//                     duration_days: subscription?.duration_days,
//                     final_price: finalPrice,
//                     plan_type: subscription?.plan_type,
//                   },
//                 },
//               });
//             } catch (error) {
//               console.error("Cancel order error:", error);

//               navigate("/thankyou", {
//                 state: {
//                   paymentStatus: "cancelled",
//                   message:
//                     "Payment was cancelled, but we could not update the order status. Please try again after a few minutes.",
//                 },
//               });
//             } finally {
//               setPaymentLoading(false);
//             }
//           },
//         },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (err) {
//       console.error("Razorpay error:", err);

//       if (err.response?.data?.code === "ACTIVE_SUBSCRIPTION_EXISTS") {
//         emitToast("You already have an active subscription 🔒", "warning", 4000);
//         return;
//       }

//       emitToast(
//         err.response?.data?.message || "Payment failed. Please try again.",
//         "error"
//       );
//     } finally {
//       setPaymentLoading(false);
//     }
//   };

//   const applyPromoCode = async () => {
//     if (!promo) {
//       emitToast("Enter promo code", "warning");
//       return;
//     }

//     if (coupon) {
//       emitToast("Remove current coupon first", "warning");
//       return;
//     }

//     try {
//       const res = await api.post("/dcoupons/validate_discount_coupon", {
//         discount_code: promo,
//         type: "Subscription",
//       });

//       if (!res.data.success) {
//         emitToast(res.data.message, "error");
//         return;
//       }

//       const couponData = res.data.data;
//       setCoupon(couponData);

//       emitToast(
//         `Coupon applied! ${couponData.discount_value}% discount`,
//         "success"
//       );
//     } catch (error) {
//       emitToast(error.response?.data?.message || "Invalid coupon", "error");
//     }
//   };

//   return (
//     <>
//       <SEO
//         title="Checkout"
//         description="Browse premium stock images, wallpapers, and digital assets. Discover featured and trending products in our shop."
//         canonical="https://shaadimaterial.com/checkout"
//         keywords="stock images, wallpapers, digital assets, premium images, shop"
//         image="https://shaadimaterial.com/logo192.png"
//       />

//       <Container className="py-5">
//         <Row className="mx-0 breadcrumb_part">
//           <h3>Checkout</h3>
//           <Breadcrumb>
//             <Breadcrumb.Item>Home</Breadcrumb.Item>
//             <Breadcrumb.Item active>Checkout</Breadcrumb.Item>
//           </Breadcrumb>
//         </Row>

//         <Row className="mx-0 pt-3 pt-lg-5 checkout_part">
//           <Col md={8} lg={7} xs={12}>
//             <Card>
//               <Card.Body>
//                 <h4>Billing information</h4>

//                 <Row className="mx-0 user-dash mt-4">
//                   <Col md={6} lg={6} xs={12} className="px-2 mb-3">
//                     <label>First name</label>
//                     <InputText value={firstName} disabled />
//                   </Col>
//                   <Col md={6} lg={6} xs={12} className="px-2 mb-3">
//                     <label>Last name</label>
//                     <InputText value={lastName} disabled />
//                   </Col>
//                   <Col md={6} lg={6} xs={12} className="px-2 mb-3">
//                     <label>Email</label>
//                     <InputText value={email} disabled />
//                   </Col>
//                   <Col md={6} lg={6} xs={12} className="px-2 mb-3">
//                     <label>Phone No.</label>
//                     <InputText
//                       disabled
//                       value={
//                         addresses.find(
//                           (a) => a.customer_details_id === selectedAddressId
//                         )?.phone_no || ""
//                       }
//                     />
//                   </Col>

//                   <Col md={12} lg={12} xs={12} className="prof_content mb-4">
//                     <div className="d-flex align-items-center justify-content-between">
//                       <label className="fw-semibold">
//                         Address <span className="text-danger">*</span>
//                       </label>
//                       <Button
//                         icon="pi pi-plus"
//                         text
//                         severity="info"
//                         className="p-0"
//                         style={{ fontSize: "14px", width: "34px" }}
//                         onClick={openAddAddress}
//                         tooltip="Add Multiple Address"
//                         tooltipOptions={{ position: "top" }}
//                       />
//                     </div>

//                     {addresses.map((address) => (
//                       <div
//                         key={address.customer_details_id}
//                         className="d-flex gap-2 mt-2 position-relative"
//                       >
//                         <RadioButton
//                           name="billingAddress"
//                           value={address.customer_details_id}
//                           checked={
//                             selectedAddressId === address.customer_details_id
//                           }
//                           onChange={(e) => setSelectedAddressId(e.value)}
//                         />
//                         <div
//                           className="rounded p-2 w-100 text-light"
//                           style={{
//                             fontSize: "15px",
//                             lineHeight: "1.6",
//                             letterSpacing: "0.5px",
//                             border: "1px dashed #3b3b3b",
//                           }}
//                         >
//                           <div>{address.address1}</div>
//                           {address.address2 && <div>{address.address2}</div>}
//                           <div>
//                             {address.city}, {address.state}
//                           </div>
//                           <div>
//                             {address.country} - {address.zipcode}
//                           </div>
//                         </div>

//                         <Button
//                           icon="pi pi-pencil"
//                           text
//                           className="p-0 text-pink respbutton"
//                           onClick={() => openEditAddress(address)}
//                         />
//                       </div>
//                     ))}
//                   </Col>
//                 </Row>

//                 <Row className="mx-0 user-dash mt-4 border-top pt-4">
//                   <h4 className="mb-4">Tax identification number</h4>
//                   <Col md={12} lg={12} xs={12} className="px-2 mb-3">
//                     <label>GST/UIN registration (optional)</label>
//                     <InputText />
//                     <span
//                       className="hint-text text-light"
//                       style={{ fontSize: "14px", letterSpacing: "0.65px" }}
//                     >
//                       We apply all applicable taxes to your order based on your
//                       billing region.
//                     </span>
//                   </Col>
//                 </Row>
//               </Card.Body>
//             </Card>
//           </Col>

//           <Col md={4} lg={4} xs={12} className="mt-3 mt-lg-0">
//             <Card className="sticky-top" style={{ top: "150px", zIndex: "1" }}>
//               <Card.Header>
//                 <h4>Order Summary</h4>
//               </Card.Header>
//               <Card.Body>
//                 <Table>
//                   <thead>
//                     <tr>
//                       <th>Product</th>
//                       <th>Price</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     <tr>
//                       <td>
//                         {subscription?.sub_name} ({subscription?.duration_days} days)
//                       </td>
//                       <td>{subtotal} INR</td>
//                     </tr>

//                     <tr>
//                       <td className="text-end">
//                         <b>Subtotal</b>
//                       </td>
//                       <td>
//                         <b>{subtotal} INR</b>
//                       </td>
//                     </tr>

//                     {coupon && (
//                       <tr>
//                         <td className="text-end">
//                           <b>Discount ({coupon.discount_value}%)</b>
//                         </td>
//                         <td>
//                           <b>- {discountBase.toFixed(2)} INR</b>
//                         </td>
//                       </tr>
//                     )}

//                     <tr>
//                       <td className="text-end">
//                         <b>GST</b>
//                       </td>
//                       <td>
//                         <b>{gstAmount} INR</b>
//                       </td>
//                     </tr>

//                     <tr>
//                       <td
//                         className="text-end text-pink"
//                         style={{ fontSize: "24px" }}
//                       >
//                         <b className="text-pink">Total</b>
//                       </td>
//                       <td className="text-pink" style={{ fontSize: "24px" }}>
//                         <b className="text-pink">{finalPrice.toFixed(2)} INR</b>
//                       </td>
//                     </tr>
//                   </tbody>
//                 </Table>

//                 <div className="my-3">
//                   <div className="d-flex justify-content-start gap-2 align-items-start">
//                     <Checkbox
//                       onChange={(e) => setChecked(e.checked)}
//                       checked={checked}
//                       className="pt-1"
//                     />
//                     <p className="text-light" style={{ fontSize: "14px" }}>
//                       I want emails with visual inspiration, special offers and more.
//                     </p>
//                   </div>
//                   <p className="text-light" style={{ fontSize: "14px" }}>
//                     By joining Shaadi material, you accept our
//                     <Link
//                       className="text-pink px-1"
//                       onClick={() => setVisible2(true)}
//                     >
//                       Privacy Policy
//                     </Link>
//                     &
//                     <Link
//                       className="text-pink px-1"
//                       onClick={() => setVisible(true)}
//                     >
//                       {" "}
//                       Terms of Use.
//                     </Link>
//                     Taxes and currency are determined using your billing address.
//                   </p>
//                 </div>

//                 <Button
//                   label={paymentLoading ? "Processing..." : "I agree - Pay now"}
//                   className="py-2 w-100 d-block my-3 custbuttonpink"
//                   style={{ fontSize: "24px" }}
//                   disabled={!checked || paymentLoading}
//                   loading={paymentLoading}
//                   onClick={startRazorpayPayment}
//                 />
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Container>

//       <Dialog
//         visible={visible}
//         style={{ width: "50vw", height: "70vh" }}
//         onHide={() => {
//           if (!visible) return;
//           setVisible(false);
//         }}
//       >
//         <TermsAndCondition />
//       </Dialog>

//       <Dialog
//         visible={visible2}
//         style={{ width: "50vw", height: "70vh" }}
//         onHide={() => {
//           if (!visible2) return;
//           setVisible2(false);
//         }}
//       >
//         <Privacypolicy />
//       </Dialog>

//       <Sidebar
//         visible={sidebarVisible}
//         position="right"
//         onHide={() => setSidebarVisible(false)}
//         className="shortCartSide"
//         style={{ width: "500px" }}
//       >
//         <h4 className="mb-4 text-light">
//           {editingAddress?.customer_details_id ? "Edit Address" : "Add New Address"}
//         </h4>

//         <div className="d-flex flex-column gap-2 mt-3 user-dash">
//           <div className="d-flex flex-column gap-1">
//             <label className="text-light">Phone Number</label>
//             <InputText
//               placeholder="Enter phone number"
//               value={editingAddress?.phone_no || ""}
//               onChange={(e) =>
//                 setEditingAddress((prev) => ({
//                   ...prev,
//                   phone_no: e.target.value,
//                 }))
//               }
//             />
//           </div>

//           <div className="d-flex flex-column gap-1">
//             <label className="text-light">Address Line 1</label>
//             <InputText
//               placeholder="House no, Street name"
//               value={editingAddress?.address1 || ""}
//               onChange={(e) =>
//                 setEditingAddress((prev) => ({
//                   ...prev,
//                   address1: e.target.value,
//                 }))
//               }
//             />
//           </div>

//           <div className="d-flex flex-column gap-1">
//             <label className="text-light">Address Line 2 (Optional)</label>
//             <InputText
//               placeholder="Apartment, landmark"
//               value={editingAddress?.address2 || ""}
//               onChange={(e) =>
//                 setEditingAddress((prev) => ({
//                   ...prev,
//                   address2: e.target.value,
//                 }))
//               }
//             />
//           </div>

//           <div className="d-flex flex-column gap-1">
//             <label className="text-light">City</label>
//             <InputText
//               placeholder="City"
//               value={editingAddress?.city || ""}
//               onChange={(e) =>
//                 setEditingAddress((prev) => ({
//                   ...prev,
//                   city: e.target.value,
//                 }))
//               }
//             />
//           </div>

//           <div className="d-flex flex-column gap-1">
//             <label className="text-light">State</label>
//             <InputText
//               placeholder="State"
//               value={editingAddress?.state || ""}
//               onChange={(e) =>
//                 setEditingAddress((prev) => ({
//                   ...prev,
//                   state: e.target.value,
//                 }))
//               }
//             />
//           </div>

//           <div className="d-flex flex-column gap-1">
//             <label className="text-light">Country</label>
//             <InputText
//               placeholder="Country"
//               value={editingAddress?.country || "India"}
//               onChange={(e) =>
//                 setEditingAddress((prev) => ({
//                   ...prev,
//                   country: e.target.value,
//                 }))
//               }
//             />
//           </div>

//           <div className="d-flex flex-column gap-1">
//             <label className="text-light">Zipcode</label>
//             <InputText
//               placeholder="Postal code"
//               value={editingAddress?.zipcode || ""}
//               onChange={(e) =>
//                 setEditingAddress((prev) => ({
//                   ...prev,
//                   zipcode: e.target.value,
//                 }))
//               }
//             />
//           </div>

//           <div className="d-flex align-items-center gap-2 mt-2">
//             <Checkbox
//               checked={editingAddress?.is_default || false}
//               onChange={(e) =>
//                 setEditingAddress((prev) => ({
//                   ...prev,
//                   is_default: e.checked,
//                 }))
//               }
//             />
//             <label className="text-light" style={{ fontSize: "15px" }}>
//               Set as default address
//             </label>
//           </div>

//           <div className="d-flex justify-content-end mt-4">
//             <Button
//               label="Save Address"
//               className="py-2"
//               severity="warning"
//               style={{ width: "fit-content" }}
//               onClick={saveAddress}
//               disabled={loading}
//             />
//           </div>
//         </div>
//       </Sidebar>
//     </>
//   );
// };

// export default Checkout;




import React, { useState, useEffect } from "react";
import { Row, Col, Breadcrumb, Card, Container, Table } from "react-bootstrap";
import "../assets/css/Checkout.css";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import { Dialog } from "primereact/dialog";
import Privacypolicy from "../pages/Policy/Privacypolicy";
import TermsAndCondition from "../pages/Policy/TermsAndCondition";
import api from "../api/axios";
import { Sidebar } from "primereact/sidebar";
import { toast, Bounce } from "react-toastify";
import SEO from "../components/SEO";
import { loadRazorpayScript } from "../utils/loadRazorpayScript";

const emitToast = (message, type = "default", autoClose = 5000) => {
  toast(message, {
    position: "bottom-left",
    autoClose,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    theme: "dark",
    transition: Bounce,
    type,
  });
};

const Checkout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const subscriptionId = location.state?.subscriptionId;

  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [loading, setLoading] = useState(true);
  const [paymentLoading, setPaymentLoading] = useState(false);

  const [subscription, setSubscription] = useState(null);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [addresses, setAddresses] = useState([]);
  const [defaultAddressId, setDefaultAddressId] = useState(null);
  const [selectedAddressId, setSelectedAddressId] = useState(null);

  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);

  const [checked, setChecked] = useState(false);
  const [showPromo, setShowPromo] = useState(false);
  const [promo, setPromo] = useState("");

  const [coupon, setCoupon] = useState(null);
  const removeCoupon = () => {
    setCoupon(null);
    setPromo("");
    emitToast("Coupon removed", "info", 2000);
  };

  useEffect(() => {
    if (!subscriptionId) {
      navigate("/pricing");
      return;
    }

    const fetchSubscription = async () => {
      try {
        const res = await api.get(
          `/SubscriptionRoutes/subscriptions/${subscriptionId}`
        );
        setSubscription(res.data.data);
      } catch (err) {
        console.error("Invalid subscription");
        navigate("/pricing");
      } finally {
        setLoading(false);
      }
    };

    fetchSubscription();
  }, [subscriptionId, navigate]);

  const regularPrice = Number(
    subscription?.strikethrough_price ??
    subscription?.price ??
    0
  );

  const selectedPlanPrice = Number(
    subscription?.display_price ??
    (subscription?.is_waitlist_offer
      ? subscription?.waitlist_price
      : subscription?.price) ??
    0
  );

  const formatAmount = (value) => {
    const amount = Number(value);

    if (!Number.isFinite(amount)) {
      return null;
    }

    return amount.toFixed(2);
  };

  const isWaitlistOffer = Boolean(
    subscription?.is_waitlist_offer
  );

  const couponDiscountAmount = coupon
    ? Number(
      (
        selectedPlanPrice *
        (Number(coupon.discount_value) / 100)
      ).toFixed(2)
    )
    : 0;

  const finalPrice = Number(
    Math.max(
      selectedPlanPrice - couponDiscountAmount,
      0
    ).toFixed(2)
  );

  const selectedAddress =
    addresses.find(
      (address) =>
        address.customer_details_id ===
        selectedAddressId
    ) || null;

  const updateSelectedAddressGst = (value) => {
    const formattedValue = String(value || "")
      .toUpperCase()
      .replace(/\s/g, "")
      .slice(0, 15);

    setAddresses((prev) =>
      prev.map((address) =>
        address.customer_details_id ===
          selectedAddressId
          ? {
            ...address,
            gst_no: formattedValue,
          }
          : address
      )
    );
  };

  const openAddAddress = () => {
    setEditingAddress({
      phone_no: "",
      address_type: "shipping",
      is_default: false,
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "India",
      zipcode: "",
      gst_no: "",
    });
    setSidebarVisible(true);
  };

  const openEditAddress = (address) => {
    setEditingAddress({ ...address });
    setSidebarVisible(true);
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await api.get(
          `/customerProfileRoutes/customer_profile_data`
        );

        if (res.data.success) {
          const customer = res.data.data;

          setFirstName(customer.C_fname);
          setLastName(customer.C_lname);
          setEmail(customer.C_email);
          setChecked(customer.is_subscribed);

          if (customer.details?.length) {
            setAddresses(customer.details);

            const defaultAddr = customer.details.find((d) => d.is_default);
            setDefaultAddressId(defaultAddr?.customer_details_id || null);
          } else {
            setAddresses([]);
          }
        }
      } catch (err) {
        console.error("Profile fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    if (addresses.length > 0) {
      const defaultAddr = addresses.find((a) => a.is_default);
      setSelectedAddressId(
        defaultAddr
          ? defaultAddr.customer_details_id
          : addresses[0].customer_details_id
      );
    }
  }, [addresses]);

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <h4>Loading checkout...</h4>
      </Container>
    );
  }

  const saveAddress = async () => {
    if (!editingAddress) return;

    try {
      setLoading(true);

      const payload = {
        customer_details_id: editingAddress.customer_details_id || undefined,
        phone_no: editingAddress.phone_no,
        address_type: editingAddress.address_type || "shipping",
        is_default: editingAddress.is_default,
        address1: editingAddress.address1,
        address2: editingAddress.address2,
        city: editingAddress.city,
        state: editingAddress.state,
        country: editingAddress.country || "India",
        zipcode: editingAddress.zipcode,
        gst_no: editingAddress.gst_no || null,
      };

      const { data } = await api.post(
        `/customerProfileRoutes/customer/address_update`,
        payload
      );

      if (!data.success) return;

      const savedAddress = {
        ...data.data,
        gst_no:
          data.data?.gst_no ??
          editingAddress.gst_no ??
          null,
      };

      setAddresses((prev) => {
        if (editingAddress.customer_details_id) {
          return prev.map((addr) =>
            addr.customer_details_id === savedAddress.customer_details_id
              ? savedAddress
              : savedAddress.is_default
                ? { ...addr, is_default: false }
                : addr
          );
        }

        return savedAddress.is_default
          ? [...prev.map((addr) => ({ ...addr, is_default: false })), savedAddress]
          : [...prev, savedAddress];
      });

      if (savedAddress.is_default) {
        setDefaultAddressId(savedAddress.customer_details_id);
      }

      setSidebarVisible(false);
      setEditingAddress(null);
    } catch (error) {
      console.error("Save address error:", error);
    } finally {
      setLoading(false);
    }
  };

  const startRazorpayPayment = async () => {
    if (paymentLoading) return;

    try {
      if (!selectedAddress) {
        emitToast("Please select a billing address", "warning", 3000);
        return;
      }

      setPaymentLoading(true);

      const razorpayLoaded = await loadRazorpayScript();

      if (!razorpayLoaded) {
        emitToast("Failed to load payment gateway", "error", 3000);
        return;
      }

      emitToast("Initializing payment…", "info", 2000);

      const { data } = await api.post(`/paymentrzrrts/payments/create-order`, {
        subscription_id: subscription.subscription_id,
        discount_code: coupon?.discount_code || null,
        address: {
          customer_details_id: selectedAddress.customer_details_id,
          phone: selectedAddress.phone_no,
          email,
          address1: selectedAddress.address1,
          address2: selectedAddress.address2,
          city: selectedAddress.city,
          state: selectedAddress.state,
          country: selectedAddress.country,
          zipcode: selectedAddress.zipcode,
          gst_no: selectedAddress.gst_no || null,
        },
      });

      if (!data?.success) {
        emitToast("Failed to initialize payment", "error");
        return;
      }

      const { razorpay_subscription_id, customer_order_id, key } = data.data;

      const options = {
        key,
        subscription_id: razorpay_subscription_id,
        name: "Shaadi Material",
        description: subscription.sub_name,

        handler: async (response) => {
          try {
            emitToast("Verifying payment…", "info", 2000);

            const verifyRes = await api.post(`/paymentrzrrts/payments/verify`, {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_subscription_id,
              customer_order_id,
              subscription_id: subscription.subscription_id,
              customer_details_id: selectedAddress.customer_details_id,
            });

            const verifyData = verifyRes.data?.data;

            emitToast("Payment successful 🎉", "success", 4000);

            navigate("/thankyou", {
              state: {
                paymentStatus: "success",
                verifyData,
                customer: {
                  firstName,
                  lastName,
                  email,
                },
                address: selectedAddress,
              },
            });
          } catch (verifyErr) {
            console.error("Verify error:", verifyErr);

            emitToast(
              verifyErr.response?.data?.message || "Payment verification failed",
              "error"
            );

            navigate("/thankyou", {
              state: {
                paymentStatus: "failed",
                message:
                  verifyErr.response?.data?.message || "Payment verification failed",
              },
            });
          } finally {
            setPaymentLoading(false);
          }
        },

        prefill: {
          name: `${firstName} ${lastName}`,
          email,
          contact: selectedAddress.phone_no,
        },

        theme: { color: "#c59d5f" },

        modal: {
          ondismiss: async () => {
            try {
              emitToast("Payment cancelled", "info", 2500);

              if (customer_order_id) {
                await api.post("/paymentrzrrts/payments/cancel-order", {
                  customer_order_id,
                });
              }

              navigate("/thankyou", {
                state: {
                  paymentStatus: "cancelled",
                  message: "You cancelled the payment before completing it.",
                  customer: {
                    firstName,
                    lastName,
                    email,
                  },
                  subscription: {
                    subscription_id:
                      subscription?.subscription_id,
                    sub_name:
                      subscription?.sub_name,
                    duration_days:
                      subscription?.duration_days,
                    plan_type:
                      subscription?.plan_type,
                    credits_per_month:
                      subscription?.credits_per_month,
                    regular_price:
                      regularPrice,
                    selected_price:
                      selectedPlanPrice,
                    final_price:
                      finalPrice,
                    is_waitlist_offer:
                      isWaitlistOffer,
                  },
                },
              });
            } catch (error) {
              console.error("Cancel order error:", error);

              navigate("/thankyou", {
                state: {
                  paymentStatus: "cancelled",
                  message:
                    "Payment was cancelled, but we could not update the order status. Please try again after a few minutes.",
                },
              });
            } finally {
              setPaymentLoading(false);
            }
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error("Razorpay error:", err);

      if (err.response?.data?.code === "ACTIVE_SUBSCRIPTION_EXISTS") {
        emitToast("You already have an active subscription 🔒", "warning", 4000);
        return;
      }

      emitToast(
        err.response?.data?.message || "Payment failed. Please try again.",
        "error"
      );
    } finally {
      setPaymentLoading(false);
    }
  };

  const applyPromoCode = async () => {
    if (isWaitlistOffer) {
      emitToast(
        "Coupons cannot be combined with the waitlist offer",
        "warning"
      );
      return;
    }

    if (!promo) {
      emitToast("Enter promo code", "warning");
      return;
    }

    if (coupon) {
      emitToast("Remove current coupon first", "warning");
      return;
    }

    try {
      const res = await api.post("/dcoupons/validate_discount_coupon", {
        discount_code: promo,
        type: "Subscription",
      });

      if (!res.data.success) {
        emitToast(res.data.message, "error");
        return;
      }

      const couponData = res.data.data;
      setCoupon(couponData);

      emitToast(
        `Coupon applied! ${couponData.discount_value}% discount`,
        "success"
      );
    } catch (error) {
      emitToast(error.response?.data?.message || "Invalid coupon", "error");
    }
  };

  return (
    <>
      <SEO
        title="Checkout"
        description="Browse premium stock images, wallpapers, and digital assets. Discover featured and trending products in our shop."
        canonical="https://shaadimaterial.com/checkout"
        keywords="stock images, wallpapers, digital assets, premium images, shop"
        image="https://shaadimaterial.com/logo192.png"
      />

      <Container className="py-5">
        <Row className="mx-0 breadcrumb_part">
          <h3>Checkout</h3>
          <Breadcrumb>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Checkout</Breadcrumb.Item>
          </Breadcrumb>
        </Row>

        <Row className="mx-0 pt-3 pt-lg-5 checkout_part">
          <Col md={8} lg={7} xs={12}>
            <Card>
              <Card.Body>
                <h4>Billing information</h4>

                <Row className="mx-0 user-dash mt-4">
                  <Col md={6} lg={6} xs={12} className="px-2 mb-3">
                    <label>First name</label>
                    <InputText value={firstName} disabled />
                  </Col>
                  <Col md={6} lg={6} xs={12} className="px-2 mb-3">
                    <label>Last name</label>
                    <InputText value={lastName} disabled />
                  </Col>
                  <Col md={6} lg={6} xs={12} className="px-2 mb-3">
                    <label>Email</label>
                    <InputText value={email} disabled />
                  </Col>
                  <Col md={6} lg={6} xs={12} className="px-2 mb-3">
                    <label>Phone No.</label>
                    <InputText
                      disabled
                      value={
                        addresses.find(
                          (a) => a.customer_details_id === selectedAddressId
                        )?.phone_no || ""
                      }
                    />
                  </Col>

                  <Col md={12} lg={12} xs={12} className="prof_content mb-4">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="fw-semibold">
                        Address <span className="text-danger">*</span>
                      </label>
                      <Button
                        icon="pi pi-plus"
                        text
                        severity="info"
                        className="p-0"
                        style={{ fontSize: "14px", width: "34px" }}
                        onClick={openAddAddress}
                        tooltip="Add Multiple Address"
                        tooltipOptions={{ position: "top" }}
                      />
                    </div>

                    {addresses.map((address) => (
                      <div
                        key={address.customer_details_id}
                        className="d-flex gap-2 mt-2 position-relative"
                      >
                        <RadioButton
                          name="billingAddress"
                          value={address.customer_details_id}
                          checked={
                            selectedAddressId === address.customer_details_id
                          }
                          onChange={(e) => setSelectedAddressId(e.value)}
                        />
                        <div
                          className="rounded p-2 w-100 text-light"
                          style={{
                            fontSize: "15px",
                            lineHeight: "1.6",
                            letterSpacing: "0.5px",
                            border: "1px dashed #3b3b3b",
                          }}
                        >
                          <div>{address.address1}</div>
                          {address.address2 && <div>{address.address2}</div>}
                          <div>
                            {address.city}, {address.state}
                          </div>
                          <div>
                            {address.country} - {address.zipcode}
                          </div>
                        </div>

                        <Button
                          icon="pi pi-pencil"
                          text
                          className="p-0 text-pink respbutton"
                          onClick={() => openEditAddress(address)}
                        />
                      </div>
                    ))}
                  </Col>
                </Row>

                <Row className="mx-0 user-dash mt-4 border-top pt-4">
                  <Col md={12} lg={12} xs={12} className="px-2 mb-3">
                    <h4 className="mb-3">GST Details</h4>

                    <label>
                      GST Number
                      <span
                        className="text-light ms-1"
                        style={{
                          fontSize: "13px",
                          opacity: 0.7,
                        }}
                      >
                        (Optional)
                      </span>
                    </label>

                    <InputText
                      value={selectedAddress?.gst_no || ""}
                      onChange={(e) =>
                        updateSelectedAddressGst(e.target.value)
                      }
                      placeholder="Enter 15-character GST number"
                      maxLength={15}
                      disabled={!selectedAddress}
                      className="w-100"
                    />

                    <span
                      className="hint-text text-light d-block mt-2"
                      style={{
                        fontSize: "14px",
                        letterSpacing: "0.4px",
                        opacity: 0.8,
                      }}
                    >
                      The GST number will be added to your invoice.
                      No GST calculation is displayed separately at checkout.
                    </span>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} lg={4} xs={12} className="mt-3 mt-lg-0">
            <Card className="sticky-top" style={{ top: "150px", zIndex: "1" }}>
              <Card.Header>
                <h4>Order Summary</h4>
              </Card.Header>
              <Card.Body>
                <Table>
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div className="fw-semibold">
                          {subscription?.sub_name || "Selected subscription"}
                        </div>

                        <div
                          className="text-light mt-1"
                          style={{
                            fontSize: "13px",
                            opacity: 0.8,
                          }}
                        >
                          {subscription?.plan_type || "Subscription"}
                          {subscription?.duration_days
                            ? ` • ${subscription.duration_days} days`
                            : ""}
                        </div>

                        {subscription?.credits_per_month != null && (
                          <div
                            className="text-light mt-1"
                            style={{
                              fontSize: "13px",
                              opacity: 0.8,
                            }}
                          >
                            {subscription.credits_per_month} credits per month
                          </div>
                        )}

                        {isWaitlistOffer && (
                          <div
                            className="text-success mt-2 fw-semibold"
                            style={{ fontSize: "13px" }}
                          >
                            Waitlist offer applied
                          </div>
                        )}
                      </td>

                      <td className="text-end">
                        {/* {formatAmount(subscription?.strikethrough_price) && (
                          <span>
                            ₹{formatAmount(subscription.strikethrough_price)}
                          </span>
                        )} */}
                        {isWaitlistOffer &&
                          regularPrice > selectedPlanPrice && (
                            <div>
                              <del
                                className="text-light"
                                style={{
                                  fontSize: "13px",
                                  opacity: 0.7,
                                  display: "block",
                                }}
                              >
                                ₹{regularPrice.toFixed(2)}
                              </del>
                            </div>
                          )}

                        <b>
                          ₹{selectedPlanPrice.toFixed(2)}
                        </b>
                      </td>
                    </tr>

                    {coupon && (
                      <tr>
                        <td className="text-end">
                          <b>
                            Discount ({coupon.discount_value}%)
                          </b>
                        </td>
                        <td className="text-end">
                          <b>
                            - ₹{couponDiscountAmount.toFixed(2)}
                          </b>
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td
                        className="text-end text-pink"
                        style={{ fontSize: "24px" }}
                      >
                        <b className="text-pink">Total</b>
                      </td>

                      <td
                        className="text-end text-pink"
                        style={{ fontSize: "24px" }}
                      >
                        <b className="text-pink">
                          ₹{finalPrice.toFixed(2)}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </Table>

                <div className="my-3">
                  <div className="d-flex justify-content-start gap-2 align-items-start">
                    <Checkbox
                      onChange={(e) => setChecked(e.checked)}
                      checked={checked}
                      className="pt-1"
                    />
                    <p className="text-light" style={{ fontSize: "14px" }}>
                      I want emails with visual inspiration, special offers and more.
                    </p>
                  </div>
                  <p className="text-light" style={{ fontSize: "14px" }}>
                    By joining Shaadi material, you accept our
                    <Link
                      className="text-pink px-1"
                      onClick={() => setVisible2(true)}
                    >
                      Privacy Policy
                    </Link>
                    &
                    <Link
                      className="text-pink px-1"
                      onClick={() => setVisible(true)}
                    >
                      {" "}
                      Terms of Use.
                    </Link>
                  </p>
                </div>

                <Button
                  label={paymentLoading ? "Processing..." : "I agree - Pay now"}
                  className="py-2 w-100 d-block my-3 custbuttonpink"
                  style={{ fontSize: "24px" }}
                  disabled={!checked || paymentLoading}
                  loading={paymentLoading}
                  onClick={startRazorpayPayment}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Dialog
        visible={visible}
        style={{ width: "50vw", height: "70vh" }}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
      >
        <TermsAndCondition />
      </Dialog>

      <Dialog
        visible={visible2}
        style={{ width: "50vw", height: "70vh" }}
        onHide={() => {
          if (!visible2) return;
          setVisible2(false);
        }}
      >
        <Privacypolicy />
      </Dialog>

      <Sidebar
        visible={sidebarVisible}
        position="right"
        onHide={() => setSidebarVisible(false)}
        className="shortCartSide"
        style={{ width: "500px" }}
      >
        <h4 className="mb-4 text-light">
          {editingAddress?.customer_details_id ? "Edit Address" : "Add New Address"}
        </h4>

        <div className="d-flex flex-column gap-2 mt-3 user-dash">
          <div className="d-flex flex-column gap-1">
            <label className="text-light">Phone Number</label>
            <InputText
              placeholder="Enter phone number"
              value={editingAddress?.phone_no || ""}
              onChange={(e) =>
                setEditingAddress((prev) => ({
                  ...prev,
                  phone_no: e.target.value,
                }))
              }
            />
          </div>

          <div className="d-flex flex-column gap-1">
            <label className="text-light">Address Line 1</label>
            <InputText
              placeholder="House no, Street name"
              value={editingAddress?.address1 || ""}
              onChange={(e) =>
                setEditingAddress((prev) => ({
                  ...prev,
                  address1: e.target.value,
                }))
              }
            />
          </div>

          <div className="d-flex flex-column gap-1">
            <label className="text-light">Address Line 2 (Optional)</label>
            <InputText
              placeholder="Apartment, landmark"
              value={editingAddress?.address2 || ""}
              onChange={(e) =>
                setEditingAddress((prev) => ({
                  ...prev,
                  address2: e.target.value,
                }))
              }
            />
          </div>

          <div className="d-flex flex-column gap-1">
            <label className="text-light">City</label>
            <InputText
              placeholder="City"
              value={editingAddress?.city || ""}
              onChange={(e) =>
                setEditingAddress((prev) => ({
                  ...prev,
                  city: e.target.value,
                }))
              }
            />
          </div>

          <div className="d-flex flex-column gap-1">
            <label className="text-light">State</label>
            <InputText
              placeholder="State"
              value={editingAddress?.state || ""}
              onChange={(e) =>
                setEditingAddress((prev) => ({
                  ...prev,
                  state: e.target.value,
                }))
              }
            />
          </div>

          <div className="d-flex flex-column gap-1">
            <label className="text-light">Country</label>
            <InputText
              placeholder="Country"
              value={editingAddress?.country || "India"}
              onChange={(e) =>
                setEditingAddress((prev) => ({
                  ...prev,
                  country: e.target.value,
                }))
              }
            />
          </div>

          <div className="d-flex flex-column gap-1">
            <label className="text-light">Zipcode</label>
            <InputText
              placeholder="Postal code"
              value={editingAddress?.zipcode || ""}
              onChange={(e) =>
                setEditingAddress((prev) => ({
                  ...prev,
                  zipcode: e.target.value,
                }))
              }
            />
          </div>

          <div className="d-flex flex-column gap-1">
            <label className="text-light">
              GST Number (Optional)
            </label>

            <InputText
              placeholder="Enter 15-character GST number"
              maxLength={15}
              value={editingAddress?.gst_no || ""}
              onChange={(e) =>
                setEditingAddress((prev) => ({
                  ...prev,
                  gst_no: String(e.target.value || "")
                    .toUpperCase()
                    .replace(/\s/g, "")
                    .slice(0, 15),
                }))
              }
            />
          </div>

          <div className="d-flex align-items-center gap-2 mt-2">
            <Checkbox
              checked={editingAddress?.is_default || false}
              onChange={(e) =>
                setEditingAddress((prev) => ({
                  ...prev,
                  is_default: e.checked,
                }))
              }
            />
            <label className="text-light" style={{ fontSize: "15px" }}>
              Set as default address
            </label>
          </div>

          <div className="d-flex justify-content-end mt-4">
            <Button
              label="Save Address"
              className="py-2"
              severity="warning"
              style={{ width: "fit-content" }}
              onClick={saveAddress}
              disabled={loading}
            />
          </div>
        </div>
      </Sidebar>
    </>
  );
};

export default Checkout;